import { render } from "./EmptyBlock.vue?vue&type=template&id=28469b4f&scoped=true&ts=true"
import script from "./EmptyBlock.vue?vue&type=script&lang=ts"
export * from "./EmptyBlock.vue?vue&type=script&lang=ts"

import "./EmptyBlock.vue?vue&type=style&index=0&id=28469b4f&scoped=true&lang=scss"

import exportComponent from "/home/iskra/Projects/verum/admin-panel/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28469b4f"]])

export default __exports__